var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,63.8C14.5,63.8,0.2,49.5,0.2,32S14.5,0.2,32,0.2S63.8,14.4,63.8,32S49.5,63.8,32,63.8z M32,5.1 C17.1,5.1,5.1,17.1,5.1,32s12,26.9,26.9,26.9s26.9-12,26.9-26.9S46.9,5.1,32,5.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,38.6l-3.2,1.7L43.7,34c-0.3-1-0.6-1.8-1-2.5l-0.3-0.6L42.1,31h-11v-5h8.4v-4.1h-8.4V19 c2-1.1,2.7-3.4,1.9-5.6c-0.5-1.1-1.3-2-2.4-2.4c-1.1-0.5-2.3-0.4-3.3,0c-1.1,0.5-2,1.3-2.4,2.4c-0.5,1.1-0.4,2.3,0,3.3 c0.4,1,1.1,1.8,2.1,2.3v3.6c-8.3,0.8-14.7,8-14.3,16.6c0.4,8.4,7.4,15,15.9,15c0.3,0,0.5,0,0.8,0c6.9-0.4,12.6-5.1,14.4-11.6 l1.6,2.8l7-3.3L50.3,38.6z M39.6,35.1l1,1.8c0.2,0.6,0.2,1.2,0.2,1.8c0,6.7-5.5,12.1-12.2,12.1c-6.7,0-12.1-5.5-12.1-12.2 c0-6.1,4.6-11.2,10.6-12.1V35L39.6,35.1L39.6,35.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType25);
export default __webpack_public_path__ + "static/media/aioa-icon-type-25.d86115a7984b1cbf3c85ac0d63a9bdc9.svg";
export { ForwardRef as ReactComponent };